import { render, staticRenderFns } from "./SummarySalesCard.vue?vue&type=template&id=60409203"
import script from "./SummarySalesCard.vue?vue&type=script&lang=js"
export * from "./SummarySalesCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('60409203')) {
      api.createRecord('60409203', component.options)
    } else {
      api.reload('60409203', component.options)
    }
    module.hot.accept("./SummarySalesCard.vue?vue&type=template&id=60409203", function () {
      api.rerender('60409203', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Sales/components/SummarySalesCard.vue"
export default component.exports